<template lang="pug">
#filtrar-monitoramento-agricola
    .filtrar-monitoramento-agricola-container
        .filtrar-monitoramento-agricola-input-container
            .filtrar-monitoramento-agricola__input
                i.el-icon-search
                input(
                    v-model='pesquisa',
                    type='text',
                    :placeholder='placeholderPais()',
                    autocomplete='off',
                    @keyup.enter='pesquisar',
                    @blur='fecharLista'
                )

            .filtrar-monitoramento-agricola__resultado
                transition(name='el-zoom-in-top')
                    ul.filtrar-monitoramento-agricola__ul(
                        v-show='mostrarResultado'
                    )
                        .mb-2(v-for='resultadoPesquisa in resultadosPesquisa')
                            span.filtrar-monitoramento-agricola__categoria(
                                v-if='resultadoPesquisa.resultado.length'
                            ) {{ internacionalizarCategoria(resultadoPesquisa.categoria) }}

                            li(
                                v-for='resultado in resultadoPesquisa.resultado',
                                @click='selecionarResultado(resultado)'
                            )
                                span {{ resultado.valor }}

        .filtrar-monitoramento-agricola__button
            el-popover(placement='bottom', width='500', trigger='click')
                BaseButton.button-outline(
                    icon='lyra-icon lyra-filtro',
                    name='filtro',
                    plain,
                    slot='reference'
                ) {{ $t('mensagens.blocoFiltros.uteis.filtrosAvancados') }}

                el-form.filtro(label-position='top')
                    .filtrar-monitoramento-agricola-popover-header
                        .filtrar-monitoramento-agricola-popover-header__text {{ $t('mensagens.blocoFiltros.uteis.filtrosAvancados') }}
                        .filtrar-monitoramento-agricola-popover-header__link(
                            @click='aplicar'
                        )
                            | {{ $t('mensagens.blocoFiltros.uteis.aplicarFiltros') }}

                    .filtrar-monitoramento-agricola-popover-collapse
                        el-form-item.mb-0.filtro-accordion
                            el-collapse(
                                v-model='collapseFiltroAvancado',
                                accordion,
                                @change='abrirCollapse'
                            )
                                el-collapse-item(
                                    :title='$t("mensagens.blocoAlerta.possuiAlertas")',
                                    name='possuiAlertas'
                                )
                                    .el-collapse-item__possui-alertas
                                        el-radio(
                                            v-model='possuiAlertas',
                                            label='POSSUI'
                                        ) {{ $t('mensagens.blocoAlerta.possuiAlertas') }}
                                        el-radio(
                                            v-model='possuiAlertas',
                                            label='NAO_POSSUI'
                                        ) {{ $t('mensagens.blocoAlerta.naoPossuiAlertas') }}

                                el-collapse-item(
                                    :title='$t("mensagens.blocoAlerta.safras")',
                                    name='safras'
                                )
                                    .el-collapse-item__safras--loading(
                                        v-loading='!safras.length'
                                    )
                                        el-checkbox-group(
                                            v-model='safrasSelecionadas'
                                        )
                                            el-checkbox(
                                                v-for='(safra, index) in safras',
                                                :label='safra',
                                                :key='index'
                                            ) {{ traduzirSafraSafrinha(safra.valor) }}

                                el-collapse-item(
                                    :title='$t("mensagens.blocoFiltros.uteis.ufMunicipio")',
                                    name='localidadesNivel0',
                                    style='padding-bottom: 10px'
                                )
                                    .filtrar-monitoramento-agricola-popover-collapse__select(
                                        v-loading='!localidadesNivel0.length'
                                    )
                                        div
                                            p {{ $t('mensagens.comuns.pais') }}
                                            el-select(
                                                v-model='localidadeNivel0Selecionada',
                                                filterable,
                                                value-key='id',
                                                @change='buscarLocalidadeNivel1()',
                                                :placeholder='$t("mensagens.comuns.selecione")'
                                            )
                                                el-option(
                                                    v-for='(localidadeNivel0, index) in localidadesNivel0',
                                                    :key='index',
                                                    :label='localidadeNivel0.nome',
                                                    :value='localidadeNivel0'
                                                ) {{ localidadeNivel0.nome }}
                                        div
                                            p {{ tituloLocalidadeNivel1 }}
                                            el-select(
                                                v-model='localidadeNivel1Selecionada',
                                                filterable,
                                                value-key='id',
                                                @change='buscarLocalidadeNivel2()',
                                                :placeholder='$t("mensagens.comuns.selecione")'
                                            )
                                                el-option(
                                                    v-for='(localidadeNivel1, index) in localidadesNivel1',
                                                    :key='index',
                                                    :label='localidadeNivel1.nome',
                                                    :value='localidadeNivel1'
                                                ) {{ localidadeNivel1.nome }}
                                        div
                                            p {{ tituloLocalidadeNivel2 }}
                                            el-select(
                                                v-model='localidadeNivel2Selecionada',
                                                filterable,
                                                value-key='id',
                                                :placeholder='$t("mensagens.comuns.selecione")'
                                            )
                                                el-option(
                                                    v-for='(localidadeNivel2, index) in localidadesNivel2',
                                                    :key='index',
                                                    :label='localidadeNivel2.nome',
                                                    :value='localidadeNivel2'
                                                ) {{ localidadeNivel2.nome }}

    .filtrar-monitoramento-agricola-filtro-selecionado
        span.filtrar-monitoramento-agricola-filtro-selecionado__titulo {{ $t('mensagens.blocoFiltros.uteis.filtrosSelecionados') }}
        el-tag.filtrar-monitoramento-agricola-filtro-selecionado__tag(
            v-for='tag in tags',
            :key='tag.nome',
            closable='',
            type='success',
            @close='removerFiltro(tag)'
        )
            span {{ internacionalizarCultura(tag.nome, tag.valor) }}

        el-tag.filtrar-monitoramento-agricola-filtro-selecionado__limpar(
            v-if='tags.length',
            type='info',
            @click='limparFiltros'
        ) {{ $t('mensagens.blocoFiltros.uteis.limparFiltro') }}
            i.el-icon-delete

        span.filtrar-monitoramento-agricola-filtro-selecionado__nenhum(
            v-if='!tags.length'
        ) {{ $t('mensagens.blocoFiltros.uteis.nenhumFiltroSelecionado') }}
</template>

<script>
import MonitoramentoAgricolaService from '@/services/MonitoramentoAgricolaService';
import LocalidadeService from '@/services/LocalidadeService';
import { mapGetters, mapState } from 'vuex';
import BaseButton from '../vegaComponents/BaseButton.vue';
import safraUtils from '@/utils/safraUtils';

export default {
    name: 'FiltrarMonitoramentoAgricola',
    components: {
        BaseButton
    },

    /**
     * Retorno
     *
     * atualizar-filtro-avancado:
     * {
     *   idSafras: [],
     *   possuiAlertas: String -> 'POSUI' || 'NAO_POSSUI'
     *   idRepresentantes: [],
     *   idTerritorios: [],
     *   idLocalidadeNivel1: Number,
     *   idLocalidadeNivel2: Number
     * }
     *
     */
    emits: ['atualizar-filtro-avancado', 'remover-cultura-selecionada'],
    props: {
        cultura: {
            type: String,
            default: () => ''
        },
        filtroAlerta: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            pesquisa: '',
            tags: [],
            collapseFiltroAvancado: [''],
            safras: [],
            safrasSelecionadas: [],
            possuiAlertas: '',
            localidadesNivel0: [],
            localidadeNivel0Selecionada: {},
            tituloLocalidadeNivel1: this.$t('mensagens.blocoFiltros.uteis.uf'),
            localidadesNivel1: [],
            localidadeNivel1Selecionada: {},
            tituloLocalidadeNivel2: this.$t('mensagens.blocoFiltros.uteis.municipio'),
            localidadesNivel2: [],
            localidadeNivel2Selecionada: {},
            resultadosPesquisa: [],
            resultadosSelecionados: [],
            mostrarResultado: false,
            acaoCollapse: {
                safras: {
                    collapse: 'safras',
                    callback: 'buscarSafras'
                },
                localidadesNivel0: {
                    collapse: 'localidadesNivel0',
                    callback: 'buscarLocalidadeNivel0'
                },
                localidadesNivel1: {
                    collapse: 'localidadesNivel1',
                    callback: 'buscarLocalidadeNivel1'
                }
            },
            culturas: []
        };
    },
    watch: {
        cultura: function () {
            for (let tag of this.culturas) {
                if (tag && tag.codigo === 'CULTURA') {
                    this.culturas = [];
                }
            }
            if (this.cultura !== '') {
                this.culturas.push({
                    valor: this.cultura,
                    codigo: 'CULTURA'
                });
            }
            for (let tag of this.tags) {
                if (tag && tag.codigo === 'CULTURA') {
                    this.tags = this.tags.filter(
                        value => value.codigo !== 'CULTURA'
                    );
                }
            }
            this.tags = [...this.tags, ...this.culturas];
        },

        filtroAlerta: function () {
            if (this.filtroAlerta === true) {
                this.possuiAlertas = 'POSSUI';
                setTimeout(() => {
                    this.aplicar();
                }, 1200);
            }
        },

        '$i18n.locale': function(newLocale) {
            this.internacionalizarLocalidade();
        },

        localidadeNivel0Selecionada: function() {
            if (Object.entries(this.localidadeNivel0Selecionada).length === 0) {
                this.localidadeNivel0Selecionada = this.localidadesNivel0[1];
                this.buscarLocalidadeNivel1();
            }

            this.internacionalizarLocalidade();
        }
    },
    computed: {
        ...mapGetters(['culturaFiltrada', 'filtroMonitoramento', 'ambientePy']),
        ...mapState(['usuarioLogado'])
    },
    created() {
        if (this.filtroMonitoramento?.tags?.length > 0) {
            this.tags = this.filtroMonitoramento.tags;
        } else if (this.culturaFiltrada) {
            this.culturas = [{
                    valor: this.culturaFiltrada,
                    codigo: 'CULTURA'
                }];
            this.tags = [{
                    valor: this.culturaFiltrada,
                    codigo: 'CULTURA'
                }];
        }
    },
    methods: {
        internacionalizarCultura(nome, valor) {
            let cultura = nome || valor;

            const culturaNormalizada = cultura
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/\s+/g, '-')
                .toUpperCase();

            const translationKey = `mensagens.cultura.${culturaNormalizada}`;

            const translation = this.$t(translationKey);

            return translation !== translationKey
                ? translation
                : cultura;
        },

        async pesquisar() {
            if (!this.pesquisa) return this.limpar();
            try {
                const { data } = await MonitoramentoAgricolaService.pesquisar(
                    this.pesquisa
                );
                this.resultadosPesquisa = data;
                if (data.length !== 0) {
                    this.mostrarResultado = true;
                } else {
                    this.mostrarResultado = false;
                }

                if (!data.length) {
                    this.exibirNotify(
                        'warning',
                        this.$t('mensagens.blocoFiltros.erros.pesquisar')
                    );
                }
            } catch (error) {
                this.exibirNotify(
                    'error',
                    this.$t('mensagens.blocoFiltros.erros.filtrar')
                );
            }
        },

        aplicar() {
            let idTerritorios = [];
            for (const resultado of this.resultadosSelecionados) {
                if (resultado.filtro && resultado.filtro.idTerritorio) {
                    idTerritorios = this.resultadosSelecionados
                        .map(t => t.filtro.idTerritorio)
                        .filter(t => t);
                    break;
                }
            }
            let idRepresentantes = [];
            for (const resultado of this.resultadosSelecionados) {
                if (resultado.filtro && resultado.filtro.idRepresentante) {
                    idRepresentantes = this.resultadosSelecionados
                        .map(r => r.filtro.idRepresentante)
                        .filter(r => r);
                    break;
                }
            }

            let filtros;
            if (this.culturas.length === 0) {
                filtros = {
                    idCulturas: [],
                    possuiAlerta:
                        this.possuiAlertas !== ''
                            ? this.possuiAlertas === 'POSSUI'
                            : null,
                    idSafras: this.safrasSelecionadas.map(({ id }) => id),
                    idTerritorios: idTerritorios,
                    idRepresentantes: idRepresentantes
                };
            } else {
                filtros = {
                    possuiAlerta:
                        this.possuiAlertas !== ''
                            ? this.possuiAlertas === 'POSSUI'
                            : null,
                    idSafras: this.safrasSelecionadas.map(({ id }) => id),
                    idTerritorios: idTerritorios,
                    idRepresentantes: idRepresentantes
                };
            }
            this.tags = [
                ...this.safrasSelecionadas,
                ...this.resultadosSelecionados
            ];
            if (this.culturas.length > 0) {
                this.tags.push({
                    valor: this.cultura,
                    codigo: 'CULTURA'
                });
            }

            if (this.possuiAlertas !== '') {
                this.tags.push({
                    valor:
                        this.possuiAlertas === 'POSSUI'
                            ? this.$t('mensagens.blocoAlerta.possuiAlertas')
                            : this.$t('mensagens.blocoAlerta.naoPossuiAlertas'),
                    codigo: 'POSSUI_ALERTAS'
                });
            }

            if (this.localidadeNivel0Selecionada && this.localidadeNivel0Selecionada.id) {
                const localidadeNivel0 = {
                    id: this.localidadeNivel0Selecionada.id,
                    nome: `${this.localidadeNivel0Selecionada.sigla}`,
                    codigo: 'LOCALIDADE0'
                };
                this.tags.push(localidadeNivel0);
                filtros.idNivel0 = this.localidadeNivel0Selecionada.id;
            } else {
                filtros.idNivel0 = '';
            }

            if (this.localidadeNivel1Selecionada && this.localidadeNivel1Selecionada.id) {
                const localidadeNivel1 = {
                    id: this.localidadeNivel1Selecionada.id,
                    nome: `${this.localidadeNivel1Selecionada.sigla}`,
                    codigo: 'LOCALIDADE1'
                };
                this.tags.push(localidadeNivel1);
                filtros.idNivel1 = this.localidadeNivel1Selecionada.id;
            } else {
                filtros.idNivel1 = '';
            }

            if (this.localidadeNivel2Selecionada && this.localidadeNivel2Selecionada.id) {
                const localidadeNivel2 = {
                    id: this.localidadeNivel2Selecionada.id,
                    nome: `${this.localidadeNivel2Selecionada.nome}`,
                    codigo: 'LOCALIDADE2'
                };
                this.tags.push(localidadeNivel2);
                filtros.idNivel2 = this.localidadeNivel2Selecionada.id;
            } else {
                filtros.idNivel2 = '';
            }

            filtros = {
                ...filtros,
                tags: this.tags
            };

            if (this.culturas.length > 0) {
                this.$emit('atualizar-filtro-avancado', filtros, this.cultura);
            } else {
                this.$emit('atualizar-filtro-avancado', filtros);
            }
        },

        abrirCollapse(ref) {
            if (ref) {
                try {
                    const acao = this.acaoCollapse[ref];
                    if (!this[ref].length && typeof this[ref] !== 'string') {
                        this[acao.callback]();
                    }
                } catch (error) {
                    this.exibirNotify(
                        'error',
                        this.$t('mensagens.blocoFiltros.erros.buscarDados')
                    );
                }
            }
        },

        removerFiltro(filtro) {
            this.tags.splice(this.tags.indexOf(filtro), 1);

            this.desmarcarFiltroPopover(filtro);
            if (filtro.codigo === 'CULTURA') {
                this.$emit('remover-cultura-selecionada', filtro.valor);
                this.culturas = [];
            } else if (filtro.codigo === 'POSSUI_ALERTAS') {
                this.possuiAlertas = '';
            }
            this.aplicar();
        },

        limparFiltros() {
            this.safrasSelecionadas = [];
            this.resultadosSelecionados = [];
            this.localidadeNivel0Selecionada = {};
            this.localidadeNivel1Selecionada = {};
            this.localidadeNivel2Selecionada = {};
            this.culturas = [];
            this.possuiAlertas = '';

            this.tags.forEach(tag => {
                if (tag.codigo === 'CULTURA') {
                    setTimeout(() => {
                        this.$emit('remover-cultura-selecionada', tag.valor);
                    }, 500);
                }
            });

            this.tags = [];

            this.aplicar();
        },

        desmarcarFiltroPopover(filtro) {
            this.safrasSelecionadas = this.safrasSelecionadas.filter(
                safra => safra !== filtro
            );
            this.resultadosSelecionados = this.resultadosSelecionados.filter(
                resultado => resultado !== filtro
            );

            if (filtro.codigo === 'LOCALIDADE0') {
                this.localidadeNivel0Selecionada = {};
            }

            if (filtro.codigo === 'LOCALIDADE1') {
                this.localidadeNivel1Selecionada = {};
            }
            if (filtro.codigo === 'LOCALIDADE2') {
                this.localidadeNivel2Selecionada = {};
            }

            if (filtro.codigo === 'POSSUI_ALERTAS') {
                this.possuiAlertas = '';
            }
        },

        selecionarResultado(resultado) {
            this.adicionarResultado(resultado);

            this.aplicar();
        },

        adicionarResultado(resultado) {
            const filtro = {
                id:
                    resultado.filtro.idTerritorio ||
                    resultado.filtro.idRepresentante,
                filtro: resultado.filtro,
                nome: resultado.valor
            };

            filtro.codigo = `${filtro.id}_${filtro.nome}`;

            const adicionado = this.resultadosSelecionados.find(
                ({ codigo }) => codigo === filtro.codigo
            );

            if (!adicionado) {
                this.resultadosSelecionados.push(filtro);
            }
        },

        limpar() {
            this.mostrarResultado = false;
            this.resultadosPesquisa = [];
        },

        fecharLista() {
            // Necessário apenas por UX
            setTimeout(() => {
                this.mostrarResultado = false;
                this.resultadosPesquisa = [];
            }, 300);
        },

        async buscarSafras() {
            const { data } =
                await MonitoramentoAgricolaService.buscarSafraFiltroAvancado();
            this.safras = data;
        },

        buscarLocalidadeNivel0() {
            LocalidadeService.findNivel0()
                .then(({ data }) => {
                    setTimeout(() => {
                        this.localidadesNivel0 = data;
                        if (Object.entries(this.localidadeNivel0Selecionada).length === 0) {
                            this.localidadeNivel0Selecionada = this.localidadesNivel0[1];
                            this.buscarLocalidadeNivel1();
                        }
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados dos países.'
                    );
                    throw error;
                });
        },

        async buscarLocalidadeNivel1() {
            const { data } = await LocalidadeService.findNivel1(this.localidadeNivel0Selecionada.id);
            this.localidadesNivel1 = data;
        },

        async buscarLocalidadeNivel2() {
            const { data } = await LocalidadeService.findNivel2(this.localidadeNivel1Selecionada.id);
            this.localidadesNivel2 = data;
        },

        exibirNotify(tipo, message) {
            this.$notify[tipo]({ message });
        },

        internacionalizarCategoria(texto) {
            const categoriaMapa = {
                Pessoa: this.$t('mensagens.comuns.pessoa'),
                Território: this.$t('mensagens.territorio.titulo')
            };

            return categoriaMapa[texto] || texto;
        },

        internacionalizarLocalidade() {
            if (this.localidadeNivel0Selecionada.sigla === 'BR') {
                this.tituloLocalidadeNivel1 = this.$t('mensagens.blocoFiltros.uteis.uf');
                this.tituloLocalidadeNivel2 = this.$t('mensagens.blocoFiltros.uteis.municipio');
            }
            if (this.localidadeNivel0Selecionada.sigla === 'PY') {
                this.tituloLocalidadeNivel1 = this.$t('mensagens.blocoFiltros.uteis.paraguaiNivel1');
                this.tituloLocalidadeNivel2 = this.$t('mensagens.blocoFiltros.uteis.paraguaiNivel2');
            }
            if (this.localidadeNivel0Selecionada.sigla === 'AR') {
                this.tituloLocalidadeNivel1 = this.$t('mensagens.blocoFiltros.uteis.argentinaNivel1');
                this.tituloLocalidadeNivel2 = this.$t('mensagens.blocoFiltros.uteis.argentinaNivel2');
            }
        },

        placeholderPais() {
            if (this.ambientePy) {
                return this.$t('mensagens.blocoFiltros.uteis.placeholderAgricolaParaguai');
            } else {
                return this.$t('mensagens.blocoFiltros.uteis.placeholder');
            }
        },

        traduzirSafraSafrinha(descricao) {
            return safraUtils.traduzirSafraSafrinha(descricao);
        }
    }
};
</script>

<style lang="scss" scoped>
.filtrar-monitoramento-agricola-container {
    display: flex;
    justify-content: space-between;
}

.filtrar-monitoramento-agricola-input-container {
    width: 100%;
    height: 42px;
    border-radius: 5px;
    background: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    position: relative;
    margin-right: 10px;
}

.filtrar-monitoramento-agricola__resultado {
    position: absolute;
    width: 100%;
}

.filtrar-monitoramento-agricola__resultado__nome {
    margin: 0px 10px;
}

.filtrar-monitoramento-agricola__input {
    height: 100%;
    display: flex;
    justify-content: center;

    i.el-icon-search {
        color: var(--primary);
        font-size: 25px;
        font-weight: bold;
        display: flex;
        align-items: center;
        margin: 0 8px;
    }

    input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        border-radius: 5px;
        color: var(--primary);
    }
}

.filtrar-monitoramento-agricola__ul {
    list-style: none;
    padding: 8px 0 8px 24px;
    position: relative;
    z-index: 42;
    margin-top: 5px;
    border-radius: 5px;
    background-color: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

    li {
        padding-left: 18px;
        margin-top: 5px;
        cursor: pointer;
    }
}

.filtrar-monitoramento-agricola__categoria {
    font-weight: bold;
}

.filtrar-monitoramento-agricola-filtro-selecionado {
    margin-top: 15px;
    min-height: 42px;
}

.filtrar-monitoramento-agricola-filtro-selecionado__titulo {
    font-size: 18px;
    font-weight: 100;
}

.filtrar-monitoramento-agricola-filtro-selecionado__tag {
    margin: 0px 5px 10px 5px;
}

.filtrar-monitoramento-agricola-filtro-selecionado__limpar {
    margin: 0px 5px 10px 5px;
    i {
        padding-left: 5px;
    }
}

.filtrar-monitoramento-agricola-filtro-selecionado__nenhum {
    margin-left: 5px;
    font-weight: 100;
    font-style: italic;
    font-size: 14px;
}

.filtrar-monitoramento-agricola-popover-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    .filtrar-monitoramento-agricola-popover-header__text {
        color: var(--primary);
        font-weight: 600;
    }
    .filtrar-monitoramento-agricola-popover-header__link {
        color: #1989fa;
        text-decoration: underline;
        cursor: pointer;
    }
}

.filtrar-monitoramento-agricola-popover-collapse {
    .el-select {
        width: 100%;
    }
    .el-collapse-item div p {
        font-size: 14px;
        margin-bottom: 0.5rem;
        font-weight: 500;
    }
    .el-collapse-item__header {
        font-weight: 500;
    }
    .filtro-accordion {
        margin-top: 10px;
    }
    .el-checkbox {
        margin-right: 12px !important;
        min-width: 200px;
    }
    .el-checkbox-group {
        display: flex;
        flex-wrap: wrap;
    }
}

.filtrar-monitoramento-agricola-popover-collapse__select {
    display: flex;
    justify-content: space-between;
}

.button-outline {
    border-color: var(--primary) !important;
    color: var(--primary) !important;
    background: transparent !important;
    display: flex;
    align-items: center;

    .lyra-filtro:before {
        content: '';
        width: 15px !important;
        height: 12px !important;
        background-color: var(--primary) !important;
        margin-right: 6px;
    }
}

.el-collapse-item__possui-alertas {
    display: flex;
    gap: 24px;
}

.el-collapse-item__safras--loading {
    min-height: 100px;
}

.el-tag {
    border-radius: 20px !important;
}

.el-tag.el-tag--success {
    border-color: var(--secondary-two) !important;
    color: var(--white) !important;
    background: var(--secondary-two) !important;
}

span.filtrar-monitoramento-agricola-filtro-selecionado__limpar.el-tag.el-tag--info.el-tag--light {
    cursor: pointer;
}
</style>
